import React, { PropsWithChildren, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useCell } from '../hooks/useCell';
import { positionSelector } from '../selectors/cell.selectors';
import { CellId } from '../types/cell.type';
import { ColumnContext } from './column.context';
import { usePlot } from './plot.context';

interface Context {
  rowId: CellId;
  height: number;
  padding: number;
  y: number;
}

export const RowContext = React.createContext<Context | null>(null);

type Props = PropsWithChildren<{
  padding?: number;
  height: number;
  topOffset?: number;
  dataTestId?: string;
}>;

export const Row: React.FC<Props> = ({
  children,
  height,
  padding = 0,
  topOffset,
  dataTestId,
}) => {
  const { rootId } = usePlot();
  const parentId = useContext(ColumnContext)?.columnId ?? rootId;
  const rowId = useCell({
    type: 'row',
    height: height + 2 * padding,
    parentId,
  });
  const { y } = useSelector(positionSelector(rowId));

  return (
    <RowContext.Provider value={{ rowId, y, height, padding }}>
      {topOffset && <Row height={topOffset} />}
      {children && (
        <g
          className='row'
          transform={`translate(0, ${y})`}
          data-testid={dataTestId}
        >
          {children}
        </g>
      )}
    </RowContext.Provider>
  );
};
